export class ProjectStatusService implements IService {
  private $resource: any;
  private httpService: any;
  private configService: any;
  private notificationService: any;
  private resourceWrapperService: any;
  private baseUrl: string;

  constructor($resource: any, httpService: any, configService: any, notificationService: any, resourceWrapperService: any) {
    this.$resource = $resource;
    this.httpService = httpService;
    this.configService = configService;
    this.notificationService = notificationService;
    this.resourceWrapperService = resourceWrapperService;
    this.baseUrl = this.configService.getServerBaseUrlForResource();
  }

  public FindAll(project) {
    return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/status`, {}, {
      query: {
        method: "GET",
        isArray: true
      }
    })).query({
      id: project.id
    }).$promise;
  }
}

frontendApp.factory("ProjectStatusService", ['$resource', 'HttpService', 'ConfigService', 'NotificationService', 'ResourceWrapperService', function(resource, httpService, configService, notificationService, resourceWrapperService) {
  return new ProjectStatusService(resource, httpService, configService, notificationService, resourceWrapperService);
}]);
